/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * Intent Service focus view. significant and influential are two part format reference list. <p>Java class for focus complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="focus"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="intent" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="significant" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="influential" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Focus extends MoserObject{

	intent = null;

	significant = null;

	influential = null;



	/**
	 * Gets the value of the intent property.
	 * @return {String} possible object is {@link String}
	 */
	getIntent() {
		return this.intent;
	}

	/**
	 * Sets the value of the intent property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIntent(value) {
		var oldValue = this.intent;
		this.intent = value;
		this._setAndNotify(269, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the significant property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the significant property. <p> For example, to add a new item, do as follows: <pre> getSignificant().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getSignificant() {
		if (!this.significant) {
			this.significant = [];
		}
		return this.significant;
	}

	/**
	 * Gets the value of the influential property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the influential property. <p> For example, to add a new item, do as follows: <pre> getInfluential().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getInfluential() {
		if (!this.influential) {
			this.influential = [];
		}
		return this.influential;
	}

	/**
	 * Gets the value of the <code>significant</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetSignificant() {
		return this.significant;
	}

	/**
	 * Gets the value of the <code>influential</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetInfluential() {
		return this.influential;
	}

	/**
	 * Creates a new instance of <code>Focus</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Focus</code> object from.
	 * @return {Focus} an object of type <code>Focus</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createFocus();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addSignificantAt(position, item) {
		this._addAtAndNotify(this.getSignificant(), position, item, 270, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addSignificant(item) {
		this.addSignificantAt(this.getSignificant().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeSignificantAt(position) {
		this._removeAtAndNotify(this.getSignificant(), position, 270, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeSignificant(item) {
		var i = this.getSignificant().indexOf(item);
		if (i >= 0) {
			this.removeSignificantAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addInfluentialAt(position, item) {
		this._addAtAndNotify(this.getInfluential(), position, item, 271, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addInfluential(item) {
		this.addInfluentialAt(this.getInfluential().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeInfluentialAt(position) {
		this._removeAtAndNotify(this.getInfluential(), position, 271, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeInfluential(item) {
		var i = this.getInfluential().indexOf(item);
		if (i >= 0) {
			this.removeInfluentialAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Focus";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 269, "intent", null));
		featureList.push(this.createFeature(true, false, false, 270, "significant", null));
		featureList.push(this.createFeature(true, false, false, 271, "influential", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 269:
			this.setIntent((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 270:
			this.significant = (value);
			break;
		case 271:
			this.influential = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 269:
			return this.getIntent();
		case 270:
			return this.getSignificant();
		case 271:
			return this.getInfluential();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 269:
			return this.getIntent();
		case 270:
			return this.basicGetSignificant();
		case 271:
			return this.basicGetInfluential();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 270:
			this.addSignificantAt(position, (value));
			break;
		case 271:
			this.addInfluentialAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 270:
			this.addSignificant((value));
			break;
		case 271:
			this.addInfluential((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 270:
			this.removeSignificantAt(position);
			break;
		case 271:
			this.removeInfluentialAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 270:
			this.removeSignificant((item));
			break;
		case 271:
			this.removeInfluential((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Focus.js